
function textImageHalfBackground() {
  $(document).ready(function() {
    if ($('.paragraph--type--text-image-half-background').length) {
      $('.collapse-button').click(function() {
        $(this).prev().toggleClass('active');
      })
    }
  });
}
